module.exports = __webpack_public_path__ + "ba149e3fa52a8bf0d3e8d0308e71b82f.pdf";